import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const createPromotion = async (payload: Omit<CarouselBanner, "id">) => {
	const url = "/homepage/admin/promotion/";
	const response = await cmsClient.post<CarouselBanner>(url, payload);

	return response.data;
};

const useCreatePromotion = () => {
	const mutation = useMutation(createPromotion);

	return mutation;
};

export default useCreatePromotion;
